import { render, staticRenderFns } from "./ActiveBacklog.vue?vue&type=template&id=432b20fa&"
import script from "./ActiveBacklog.vue?vue&type=script&lang=js&"
export * from "./ActiveBacklog.vue?vue&type=script&lang=js&"
import style0 from "./ActiveBacklog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports